export enum NumericValueType{
    PositiveNumber = 1,
    NegativeNumber,
    Both
}
